export default __webpack_public_path__ + "static/context-do-4-9f85f7e7f169f6362ad0132d2f58ca6a.png";